'use strict';

angular.module('ntmApp').factory('ProfileDataService', ['ProfileConstants', 'ProfileHelper', 'EditForm', 'Constants', 'ListGridConstants',
    function (ProfileConstants, ProfileHelper, EditForm, Constants, ListGridConstants) {

    function ProfileDataService() {

        var self = this;
        var profileData = null;

        self.processProfilePageData = function (inputData, action, model, scope) {

            var data = {
                tabs: [],
                selectedTab: null
            };
            
            data.tabs.push({
                type: ProfileConstants.TabTypes.PAGE,
                title: inputData.colunmSections[0].sectionHeader,
                showTitle: inputData.colunmSections[0].showSectionHeader,
                cluetip: inputData.colunmSections[0].cluetip,
                sectionId: inputData.colunmSections[0].mdPage,
                instructions: inputData.colunmSections[0].instructions,
                data: buildPage(inputData.colunmSections, action, model)
            });

            if (scope) {

                inputData.gridSections.forEach(function (section) {
                    data.tabs.push({
                        type: ProfileConstants.TabTypes.GRID,
                        sectionId: section.sectionId,
                        title: section.sectionTitle,
                        cluetip: section.cluetip,
                        counts: ProfileHelper.getTabCount(section)
                    });
                });
            }

            if (inputData.roomPreview) {
                data.tabs.push({
                    type: ProfileConstants.TabTypes.ROOMPREVIEW,
                    sectionId: inputData.roomPreview.mdPage,
                    title: inputData.roomPreview.sectionHeader,
                    cluetip: inputData.roomPreview.cluetip,
                });

                self.hasRoomPreview = true;
            }
            else {
                self.hasRoomPreview = false;
            }

            profileData = inputData;

            return data;           
        };

        self.getInfoSectionId = function () {

            return profileData.colunmSections[0].mdPage;
        };

        self.processRoomPreviewData = function (roomPreviewData) {
            roomPreviewData.daysOfTheWeekArrayLowerCase = Constants.DaysOfTheWeekLabels.getDaysOfTheWeekLabels('lowerCaseLabel');
            roomPreviewData.daysOfTheWeekArrayShortLabel = Constants.DaysOfTheWeekLabels.getDaysOfTheWeekLabels('shortLabel');
            roomPreviewData.activityTypes = Constants.ActivityTypes;
            roomPreviewData.showInGroupingRowsOptions = ProfileConstants.ShowInGroupingRowsOptions;
            roomPreviewData.showInGroupingRowsSelectedOption = roomPreviewData.showInGroupingRowsOptions.AssignedStaffInitials;

            roomPreviewData.activityGroups.forEach(function (groupItem) {
                groupItem.isExpanded = false;
                groupItem.activitiesWithAlertsTotalCount = (groupItem.activities.filter(function (activity) {
                    return activity.hasMissingEquipment || activity.hasMissingMetrics || activity.hasMissingRackItem || activity.hasMissingRacks || activity.hasMissingRecurrence || activity.hasMissingSquareFootage;
                })).length;

                groupItem.activities.forEach(function (activity) {
                    activity.activityIcon = activity.activityIcon && activity.activityIcon.length > 0 ? '{"type": "awesome", "image": "' + activity.activityIcon + '"}' : activity.activityIcon;
                    activity.hasAlerts = activity.hasMissingEquipment || activity.hasMissingMetrics || activity.hasMissingRackItem || activity.hasMissingRacks || activity.hasMissingRecurrence || activity.hasMissingSquareFootage;

                    var scheduleItemsActivityMinutes = [];
                    var scheduleItemsAssignees = [];

                    for (var week = 0; week < 4; week++) {
                        var scheduleWeekActivityMinutes = {};
                        var scheduleWeekAssignees = {};

                        for (var day = 0 ; day < 7; day++) {
                            var scheduleDate = getScheduleDateByDay(activity.scheduleDates, 7 * week + (day+1));
                                
                            scheduleWeekActivityMinutes[roomPreviewData.daysOfTheWeekArrayLowerCase[day].label] = scheduleDate ? scheduleDate.activityMinutes : null;

                            if (scheduleDate && scheduleDate.staffId) {
                                scheduleWeekAssignees[roomPreviewData.daysOfTheWeekArrayLowerCase[day].label] = { staffId: scheduleDate.staffId, staffNameAbbr: scheduleDate.staffNameAbbr, staffName: scheduleDate.staffName, assignmentPriority: scheduleDate.assignmentPriority };
                            } else {
                                scheduleWeekAssignees[roomPreviewData.daysOfTheWeekArrayLowerCase[day].label] = null;
                            }
                        }
                        scheduleItemsActivityMinutes.push(scheduleWeekActivityMinutes);
                        scheduleItemsAssignees.push(scheduleWeekAssignees);
                    }
                    activity.scheduleItems = scheduleItemsActivityMinutes;
                    activity.scheduleItemsAssignees = scheduleItemsAssignees;

                    activity.formattedScheduleItems = angular.copy(activity.scheduleItems);

                    activity.formattedScheduleItems.forEach(function (weekItems) {
                        roomPreviewData.daysOfTheWeekArrayLowerCase.forEach(function (dayOfTheWeek) {
                            weekItems[dayOfTheWeek.label] = getFormattedTotalDurationValue(weekItems[dayOfTheWeek.label], 1);
                        });
                    });

                    activity.formattedActivityMinutes = getFormattedTotalDurationValue(activity.activityMinutes, 2);
                });

                groupItem.specificActivityIconsAggregationArrayByWeeks = [];
                groupItem.assignedStaffForDaysArrayByWeeks = [];

                for (var i = 0; i < 4; i++) {
                    groupItem.specificActivityIconsAggregationArrayByWeeks.push(getSpecificActivityIconsAggregationArray(i, groupItem));
                    groupItem.assignedStaffForDaysArrayByWeeks.push(getAssignedStaffForDaysArray(i, groupItem));
                }
            });

            roomPreviewData.roomStaffAttendanceArray = [];

            roomPreviewData.roomStaffAttendance.forEach(function (roomStaff) {
                var assignedStaffForDaysArray = [];

                for (var i = 0; i < 4; i++) {
                    assignedStaffForDaysArray[i] = [];

                    roomPreviewData.daysOfTheWeekArrayLowerCase.forEach(function (dayOfTheWeek) {
                        assignedStaffForDaysArray[i][dayOfTheWeek.label] = (getAssignedStaffForADay(roomStaff, i + 1, dayOfTheWeek.label));
                    });
                }

                roomPreviewData.roomStaffAttendanceArray.push({ items: assignedStaffForDaysArray });
            });

            roomPreviewData.qcLeadersArray = [];

            roomPreviewData.qcLeadersAttendance.forEach(function (qcLeader) {
                var qcLeadersForDaysArray = [];

                roomPreviewData.daysOfTheWeekArrayLowerCase.forEach(function (dayOfTheWeek) {                    
                    qcLeadersForDaysArray.push(getQCLeadersForADay(qcLeader, dayOfTheWeek.label));
                });

                roomPreviewData.qcLeadersArray.push({ items: qcLeadersForDaysArray });
            });

            roomPreviewData.roomStaffIsMissingArray = roomPreviewData.staffWithMissingWorkShift;

            return roomPreviewData;
        };

        // private methods

        function getScheduleDateByDay(scheduleDates, dayNumber) {
            return scheduleDates.firstOrDefault(function (scheduleItem) { return scheduleItem.dayNumber === dayNumber; });
        }

        function getFormattedTotalDurationValue(totalDurationValue, decimalsNumber) {
            var formattedTotalDurationValue = totalDurationValue;

            if (totalDurationValue) {

                if (parseFloat(totalDurationValue) >= 1) {
                    formattedTotalDurationValue = Math.round(totalDurationValue);
                } else {
                    formattedTotalDurationValue = parseFloat(Number(totalDurationValue + '').toFixed(parseInt(decimalsNumber)));
                }
            }

            return formattedTotalDurationValue;
        }

        function getAssignedStaffForADay(roomStaffAttendance, weekNumber, dayOfTheWeek) {
            var roomStaff = {};
            var dayAttendance = roomStaffAttendance.firstOrDefault(function (attendanceItem) { return attendanceItem.weekNumber === weekNumber && attendanceItem.dayString && attendanceItem.dayString.toLowerCase() === dayOfTheWeek; });

            if (dayAttendance && dayAttendance.staffId) {
                roomStaff.staffInitials = dayAttendance.staffNameAbbr;
                roomStaff.staffName = dayAttendance.staffName;
                roomStaff.shift = {};
                roomStaff.shift.formattedShiftStartTime = dayAttendance.shiftStartTime;
                roomStaff.shift.formattedShiftEndTime = dayAttendance.shiftEndTime;

                return roomStaff;
            }
            return '';
        }

        function getQCLeadersForADay(qcLeaderAttendance, dayOfTheWeek) {
            var qcLeader = {};
            var dayAttendance = qcLeaderAttendance.firstOrDefault(function (attendanceItem) { return attendanceItem.dayString.toLowerCase() === dayOfTheWeek; });

            if (dayAttendance && dayAttendance.staffId) {
                qcLeader.staffInitials = dayAttendance.staffNameAbbr;
                qcLeader.staffName = dayAttendance.staffName;
                qcLeader.shift = {};
                qcLeader.shift.formattedShiftStartTime = dayAttendance.shiftStartTime;
                qcLeader.shift.formattedShiftEndTime = dayAttendance.shiftEndTime;

                return qcLeader;
            }
            return '';
        }

        function getSpecificActivityIconsAggregationArray(weekNumber, groupItem) {
            var daysOfTheWeekArrayLowerCase = Constants.DaysOfTheWeekLabels.getDaysOfTheWeekLabels('lowerCaseLabel');
            var specificActivityIconsAggregationArray = {};

            daysOfTheWeekArrayLowerCase.forEach(function (dayOfTheWeek) {
                specificActivityIconsAggregationArray[dayOfTheWeek.label] = [];

                groupItem.activities.forEach(function (activity) {
                    if (activity.scheduleItems[weekNumber][dayOfTheWeek.label] && activity.activityIcon) {
                        if (specificActivityIconsAggregationArray[dayOfTheWeek.label].length > 0) {
                            var alreadyHasThisActivityIcon = false;

                            specificActivityIconsAggregationArray[dayOfTheWeek.label].forEach(function (existingActivityIcon) {
                                if (angular.equals(existingActivityIcon.iconJSONSource, activity.activityIcon)) {
                                    alreadyHasThisActivityIcon = true;
                                }
                            });

                            if (!alreadyHasThisActivityIcon) {
                                specificActivityIconsAggregationArray[dayOfTheWeek.label].push({ iconIndex: specificActivityIconsAggregationArray[dayOfTheWeek.label].length, iconJSONSource: activity.activityIcon });
                            }
                        } else {
                            specificActivityIconsAggregationArray[dayOfTheWeek.label].push({ iconIndex: specificActivityIconsAggregationArray[dayOfTheWeek.label].length, iconJSONSource: activity.activityIcon });
                        }
                    }
                });
            });

            return specificActivityIconsAggregationArray;
        }

        function getAssignedStaffForDaysArray(weekNumber, groupItem) {
            var daysOfTheWeekArrayLowerCase = Constants.DaysOfTheWeekLabels.getDaysOfTheWeekLabels('lowerCaseLabel');
            var assigneesArray = {};
        
            daysOfTheWeekArrayLowerCase.forEach(function (dayOfTheWeek) {
                assigneesArray[dayOfTheWeek.label] = [];
        
                groupItem.activities.forEach(function (activity) {
                    if (activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label] && activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label].staffId) {
                        assigneesArray[dayOfTheWeek.label].push({
                            staffId: activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label].staffId,
                            staffName: activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label].staffName,
                            staffNameAbbr: activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label].staffNameAbbr,
                            assignmentPriority: activity.scheduleItemsAssignees[weekNumber][dayOfTheWeek.label].assignmentPriority
                        });
                    }
                });
            });
            return assigneesArray;
        }

        function buildPage(sections, action, model) {

            return new EditForm({
                action: action,
                doNotReset: true,
                pageType: ListGridConstants.SectionType.GeneralPage,
                columAnimations: sections[0].columAnimations,
                mdPage: ProfileHelper.pageId,
                sectionId: sections[0].mdPage,
                model: model,
                generalPageSection: sections
            });
        }
    }

    return (ProfileDataService);
}]);
